<template>
  <v-container
    fluid
    class="pt-2 mx-0 grey lighten-2"
    :class="{ 'px-2': $vuetify.breakpoint.width <= 1600, 'pl-0': $vuetify.breakpoint.width > 1600 }"
  >
    <v-layout>
      <v-flex xs12 sm9 md6>
        <v-card class="pa-2">
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap class="py2">
                <v-flex xs12 sm6>
                  <image-edit-upload :url.sync="updates.logo" :path="'broker-images'"></image-edit-upload>
                </v-flex>
                <v-flex xs12 sm6>
                  <img :src="updates.logo" alt="Logo" class="responsive" />
                </v-flex>
              </v-layout>
            </v-container>
            <v-form lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap class="py-2">
                  <v-flex xs12>
                    <v-text-field label="Broker Name" v-model="updates.name"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm6 v-if="UserHasRole('Platform')">
                    <v-switch label="Website" v-model="updates.branded_site"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="UserHasRole('Platform')">
                    <v-switch label="Enabled" v-model="updates.enabled"></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout v-if="updates.branded_site" wrap class="py-2">
                  <v-flex xs12>
                    <v-text-field
                      v-if="UserHasRole('Platform')"
                      label="Broker Subdomain"
                      v-model="updates.sub_domain"
                    ></v-text-field>
                    <p v-else>
                      <small style="color:rgba(0,0,0,0.54);" class="small pb-3 d-block">Sub domain</small>
                      <a target="_blank" :href="`https://${updates.sub_domain}.funderfinder.co.uk`"
                        >https://{{ updates.sub_domain }}.funderfinder.co.uk</a
                      >
                    </p>
                  </v-flex>
                </v-layout>
                <v-layout v-if="updates.branded_site" wrap class="py-2">
                  <v-flex xs12 v-if="UserHasRole('Platform')">
                    <v-text-field label="Landing Page Header" v-model="updates.web_site_header"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout v-if="updates.branded_site" wrap class="py-2">
                  <v-flex xs12 v-if="UserHasRole('Platform')">
                    <v-text-field label="Landing Page Strap Line" v-model="updates.web_strapline"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="accent" @click="updateBroker">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ImageEditUpload from '../Partners/ImageEditUpload';

export default {
  components: { ImageEditUpload },
  data: () => ({
    updates: {
      logo: null,
      name: null,
      sub_domain: null,
      branded_site: false,
      enabled: false,
      web_site_header: null,
      web_strapline: null
    }
  }),
  name: 'broker-details',
  computed: {
    ...mapGetters(['SelectedBroker', 'UserHasRole', 'RegistrationReferrerList'])
  },
  methods: {
    ...mapActions(['updateSelectedBroker', 'addNotification']),
    updateBroker: function() {
      this.updateSelectedBroker(this.updates).then(() => {
        this.addNotification({
          text: `${this.updates.name} updated`
        });
      });
    }
  },
  watch: {
    SelectedBroker: function() {
      this.updates.logo = this.SelectedBroker.logo;
      this.updates.name = this.SelectedBroker.name;
      this.updates.sub_domain = this.SelectedBroker.sub_domain;
      this.updates.branded_site = this.SelectedBroker.branded_site;
      this.updates.enabled = this.SelectedBroker.enabled;
      this.updates.web_site_header = this.SelectedBroker.web_site_header;
      this.updates.web_strapline = this.SelectedBroker.web_strapline;
    }
  }
};
</script>

<style scoped>
img.responsive {
  width: 100%;
}
</style>
